@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-icon-styles();
}
